import { useEffect } from 'react';
import { pushBackHandler } from '../backButton';

export default function Modal({ open, onClose, children, wide }) {
  // Đóng bằng phím Esc (web) HOẶC nút back cứng Android (app) — chỉ khi đang mở.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    const popBack = pushBackHandler(() => onClose()); // back cứng -> đóng modal này
    return () => {
      window.removeEventListener('keydown', onKey);
      popBack();
    };
  }, [open, onClose]);

  // KHÔNG đóng khi bấm ra nền (tránh đóng nhầm) — chỉ đóng qua nút X / Hủy / Esc.
  return (
    <div className={`modal-bg${open ? ' show' : ''}`}>
      <div className={`modal${wide ? ' wide' : ''}`}>
        <button className="modal-x" onClick={onClose} title="Đóng (Esc)" aria-label="Đóng">
          ×
        </button>
        {children}
      </div>
    </div>
  );
}
